import { NotificationFlagsCategories } from '../../../models/NotificationFlags/NotificationFlagsCategories';
import { VDRFileView } from '../../../slices/marketplace/data-room/models/vdr-file-view.model';
import { VDRFolderView } from '../../../slices/marketplace/data-room/models/vdr-folder-view.model';
import { getFileId } from './VDRFileStatusHelper';

export const getDataRoomFileFlagCode = (
    engagementId: number,
    file: VDRFileView
): string =>
    `${NotificationFlagsCategories.DataRoomFileCode}.${engagementId}.${file.fileSourceType}.${getFileId(file)}`;

export const getFolderFileFlagCodes = (
    engagementId: number,
    folder: VDRFolderView,
    isRecursive: boolean
): Set<string> => {
    const codes = new Set<string>();
    folder.files.forEach((file) =>
        codes.add(getDataRoomFileFlagCode(engagementId, file).toLowerCase())
    );
    if (isRecursive) {
        folder.subFolders.forEach((subFolder) =>
            getFolderFileFlagCodes(engagementId, subFolder, true).forEach(
                (code) => codes.add(code)
            )
        );
    }
    return codes;
};
